import React from 'react';
import Navbar from 'src/components/Navbar';
import {navElements} from './admin-constants';

const AdminNavbar = (): React.ReactElement => {
  const {menus, avatarMenuItems, featureFlags} = navElements;

  return <Navbar menus={menus} avatarMenuItems={avatarMenuItems} featureFlags={featureFlags} />;
};

export default AdminNavbar;
